import Vue from 'vue';
import Vuex from 'vuex';
import ILocationSearchType from '../interfaces/ilocation-search-type';
import ILocation from '../interfaces/ilocation';
import actions from './actions';
import getters from './getters';
import mutations from './mutations';

Vue.use(Vuex);

const state = {
    // VM
    HasError: false,
    IsLoading: false,
    LocationSearchTypes: [] as ILocationSearchType[],
    Locations: [] as ILocation[],
    SelectedLocation: {} as ILocation,
    SelectedIndex: -1,
    FocusedIndex: -1,
    // Maps
    ShowMyLocation: true,
    GMap: {} as google.maps.Map,
    AutoComplete: {} as google.maps.places.Autocomplete,
    LocationMarkers: [] as google.maps.Marker[],
    CurrentLocationMarker: {} as google.maps.Marker,
    CurrentUserLatitude: 0,
    CurrentUserLongitude: 0,
    // Paging
    CurrentPageNumber: 1,
    TotalSearchResults: 0,
    PageSize: 10,
    TotalPages: 0,
    // Filtering
    ShowFilterButton: true,
    // Searching
    IsSearchHistorySupported: typeof (Storage) !== 'undefined',
    MaxHistoryLength: 4,
    IsSearching: false,
    HasSearched: false,
    ShowSearchHistory: false,
    SearchText: '',
    SearchHistory: [],
    SearchHistoryCoords: [],
    // Mobile
    EmblaScrollToIndex: -1,
    UsedMyLocation: false,
    MobileFiltersVisibility: false,
    MobileDetailsVisibility: false,
    IsRecentHistorySearch: false,
    SearchHistoryIndex: null
};

export default new Vuex.Store({
    state,
    getters,
    mutations,
    actions
});